import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/lp-game.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/pricing/PricingPageClientOptimized.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CPFLComparisonChart"] */ "/vercel/path0/src/components/blog/charts/CPFLComparisonChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CPLComparisonChart"] */ "/vercel/path0/src/components/blog/charts/CPLComparisonChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareableChart"] */ "/vercel/path0/src/components/blog/ShareableChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FirstPartyDataValue"] */ "/vercel/path0/src/components/Guide/charts/FirstPartyDataValue.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntegratedFunnel"] */ "/vercel/path0/src/components/Guide/charts/IntegratedFunnel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeadChannelComparison"] */ "/vercel/path0/src/components/Guide/charts/LeadChannelComparison.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MortgageFunnelFlow"] */ "/vercel/path0/src/components/Guide/charts/MortgageFunnelFlow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PartnershipROI"] */ "/vercel/path0/src/components/Guide/charts/PartnershipROI.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SEOPerformanceFlow"] */ "/vercel/path0/src/components/Guide/charts/SEOPerformanceFlow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedToLeadChart"] */ "/vercel/path0/src/components/Guide/charts/SpeedToLeadChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestingCalendar"] */ "/vercel/path0/src/components/Guide/charts/TestingCalendar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TwoEngineModel"] */ "/vercel/path0/src/components/Guide/charts/TwoEngineModel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebsiteAnatomy"] */ "/vercel/path0/src/components/Guide/charts/WebsiteAnatomy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GuideSidebar"] */ "/vercel/path0/src/components/Guide/GuideSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingProgressBar"] */ "/vercel/path0/src/components/Guide/ReadingProgressBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionNavigation"] */ "/vercel/path0/src/components/Guide/SectionNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Alert"] */ "/vercel/path0/src/components/mdx/Alert.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/vercel/path0/src/components/mdx/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureGrid"] */ "/vercel/path0/src/components/mdx/FeatureGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/vercel/path0/src/components/mdx/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/mdx/LazyComparisonTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/mdx/LazyMortgageCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyServerMortgagePathsDiagramV2","LazyMortgagePathsV2"] */ "/vercel/path0/src/components/mdx/LazyMortgagePathsDiagramV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/mdx/LazyProductArchitectureSEO.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/mdx/LazyProductArchitectureV2Shadow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/mdx/LazyTestimonial.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Modal"] */ "/vercel/path0/src/components/mdx/Modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingCard","PricingGrid"] */ "/vercel/path0/src/components/mdx/PricingCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/mdx/ProductArchitectureV2Shadow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/mdx/ReviewsWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsBar","Stat"] */ "/vercel/path0/src/components/mdx/StatsBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","Tab"] */ "/vercel/path0/src/components/mdx/Tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/vercel/path0/src/components/mdx/Video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VSLPlaceholder"] */ "/vercel/path0/src/components/mdx/VSLPlaceholder.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/MortgageSystemsDiagram.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChargebeeUpdateButton"] */ "/vercel/path0/src/components/payment/ChargebeeUpdateButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrivacyChoices"] */ "/vercel/path0/src/components/privacy/PrivacyChoices.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingCalculatorButton"] */ "/vercel/path0/src/components/tools/mortgage-calculator/FloatingCalculatorButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalculatorCTA"] */ "/vercel/path0/src/components/tools/mortgage-calculator/results/CalculatorCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalculatorResultsWrapper"] */ "/vercel/path0/src/components/tools/mortgage-calculator/results/CalculatorResultsWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MakingSenseSection"] */ "/vercel/path0/src/components/tools/mortgage-calculator/results/MakingSenseSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MidContentCTA"] */ "/vercel/path0/src/components/tools/mortgage-calculator/results/MidContentCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PatternGrid"] */ "/vercel/path0/src/components/tools/mortgage-calculator/results/PatternGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScenarioExplainer"] */ "/vercel/path0/src/components/tools/mortgage-calculator/results/ScenarioExplainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionIntro"] */ "/vercel/path0/src/components/tools/mortgage-calculator/results/SectionIntro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimelineReality"] */ "/vercel/path0/src/components/tools/mortgage-calculator/results/TimelineReality.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YourNextDecision"] */ "/vercel/path0/src/components/tools/mortgage-calculator/results/YourNextDecision.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogGridV2"] */ "/vercel/path0/src/components/v2/blog/BlogGridV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogNewsletterV2"] */ "/vercel/path0/src/components/v2/blog/BlogNewsletterV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GuideRentedOwned","GuideJourney","GuideVisitors"] */ "/vercel/path0/src/components/v2/guide/GuideFlip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LPCostFlip"] */ "/vercel/path0/src/components/v2/LPCostFlip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LPLeadFeed"] */ "/vercel/path0/src/components/v2/LPLeadFeed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LPLeakFinder"] */ "/vercel/path0/src/components/v2/LPLeakFinder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LPMagnetMount"] */ "/vercel/path0/src/components/v2/LPMagnetMount.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LPRoi"] */ "/vercel/path0/src/components/v2/LPRoi.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RoiGameLazy"] */ "/vercel/path0/src/components/v2/roi/page/RoiGameLazy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RoiBackToCalc"] */ "/vercel/path0/src/components/v2/roi/prose/RoiBackToCalc.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RoiFormLink"] */ "/vercel/path0/src/components/v2/roi/prose/RoiFormLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/lib/visual-components/core/VisualComponentTemplate.tsx");
